import { render, staticRenderFns } from "./HotSalesDetail.vue?vue&type=template&id=226b7be4&scoped=true&"
import script from "./HotSalesDetail.vue?vue&type=script&lang=js&"
export * from "./HotSalesDetail.vue?vue&type=script&lang=js&"
import style0 from "./HotSalesDetail.vue?vue&type=style&index=0&id=226b7be4&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226b7be4",
  null
  
)

export default component.exports